// SessionExpiredMessage.js
import { useLocation, Link  } from 'react-router-dom';

function SessionExpiredMessage({ sessionExpired }) {
  const location = useLocation();
  const hideExpiredMessagePaths = ['/login', '/signup', '/', '/socialglass'];

  if (sessionExpired && !hideExpiredMessagePaths.includes(location.pathname)) {
    return (
      <div className="bg-red-500 text-white text-center p-2">
        Your session has expired. Please{' '}
        <Link to="/login" className="underline font-semibold text-white hover:text-gray-200">
          log in
        </Link> {' '}
        again.
      </div>
    );
  }

  return null;
}

export default SessionExpiredMessage;